import React from "react";
import { Img } from "../Img";
import { dateService } from "../../../../services/dateService";
import { DateFormats } from "../../../../constants/dateFormats";
import { Text } from "../Text";
import { formatCurrency } from "../../../../utils/currencyFormatter";

interface ListItemProps {
  name: string;
  date: string;
  amount: number;
  profilePhoto: string;
}

const ListItem: React.FC<ListItemProps> = ({
  name,
  date,
  amount,
  profilePhoto,
}) => {
  return (
    <div className="flex flex-row bg-white-A700 rounded-lg border border-lightGray py-4 px-3 justify-between items-center">
      <div className="flex flex-row gap-2 items-center">
        <Img
          src={profilePhoto}
          alt="profile"
          className="xs:size-8 5xl:size-14 rounded-full "
        />
        <div className="flex flex-col">
          <Text className=" text-left text-sm 5xl:text-xl 5xl:font-normal">
            {name}
          </Text>
          <Text className="!text-darkGray font-medium text-xs text-left 5xl:text-xl 5xl:font-normal">
            {`${dateService.format(date, DateFormats.extended.normalDateTime)}`}
          </Text>
        </div>
      </div>

      <Text className="text-black text-sm 5xl:text-xl 5xl:font-normal">
       {formatCurrency(amount)}
      </Text>
    </div>
  );
};

export default ListItem;
